import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { SWRConfig } from 'swr';

import swrConfig from './swrConfig';
import { Navbar } from './components/Navbar';
import { OfflineBanner } from './components/OfflineBanner';
import FanpagePage from './pages/FanpagePage';
import GroupPage from './pages/GroupPage';

/**
 * App component — sets up global SWR config, routing, and page layout.
 *
 * Routes:
 *   /           → redirect to /fanpages
 *   /fanpages   → FanpagePage
 *   /groups     → GroupPage
 *
 * Requirements: 1.2, 1.3, 9.5, 9.6
 */
const App: React.FC = () => {
  return (
    <SWRConfig value={swrConfig}>
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Navigate to="/fanpages" replace />} />
          <Route path="/fanpages" element={<FanpagePage />} />
          <Route path="/groups" element={<GroupPage />} />
        </Routes>
        <OfflineBanner />
      </BrowserRouter>
    </SWRConfig>
  );
};

export default App;
